import { createTheme } from '../theme';

const theme = createTheme({
  components: {
    MuiDivider: {
      styleOverrides: {
        root: {
          width: '100%',
          color: 'text.secondary',
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          minWidth: 0,
        },
      },
    },
  },
});

export default theme.components;
